import { useSelector } from "react-redux";
import { DialogContent } from "@mui/material";
import { RootState } from "../../../redux/store";
import UserApprovalDialog from "./ApproveRejectUser";
import RegisterMailOTP from "./RegisterMailOTP";
import UpdateUserBanks from "./UpdateUserBanks";
import AddRoletoUser from "./AddRoletoUser";
import ChangePasswordDialog from "./ChangePasswordDialog";
import AddCsrCellUser from "./AddCsrCellUser";

const dialogsTypesWise: any = {

    "userapproverejectdialog": () => <UserApprovalDialog />,
    "registerMailOTP": () => <RegisterMailOTP />,
    "updateBanks": () => <UpdateUserBanks />,
    "AddRoletoUser": () => <AddRoletoUser />,
    "ChangePassword": () => <ChangePasswordDialog />,
    "AddCsrCellUser": () => <AddCsrCellUser />,

}

const dialogTypeFullScreen: any = {

}

const UsersMasterPage: React.FC = () => {
    const { type, isFullScreen } = useSelector((state: RootState) => state.dialog);

    return (
        <>
            {
                (isFullScreen && dialogTypeFullScreen[type]?.()) ?
                    (
                        <DialogContent sx={{ height: "100%", margin: 0, padding: 0 }}  > {dialogTypeFullScreen[type]?.() ?? null} </DialogContent>
                    ) : (
                        <>
                            {dialogsTypesWise[type]?.() ?? null}
                        </>
                    )
            }
        </>
    )
}
export default UsersMasterPage;



